import Application from "../../Application";
import CourtCaseConnectionTypePresenter, {
  ICourtCaseConnectionTypePresenter
} from "../presenter/CourtCaseConnectionTypePresenter";
import GetAllCourtCaseConnectionTypesInteractor from "./GetAllCourtCaseConnectionTypesInteractor";

export default class ShowCourtCaseConnectionTypesInteractor {
  private application: Application;
  private output?: ICourtCaseConnectionTypePresenter;
  private getAllCourtCaseConnectionTypesInteractor: GetAllCourtCaseConnectionTypesInteractor;

  constructor({ application, getAllCourtCaseConnectionTypes }) {
    this.application = application;
    this.getAllCourtCaseConnectionTypesInteractor =
      getAllCourtCaseConnectionTypes;
  }

  execute() {
    this.output = CourtCaseConnectionTypePresenter({
      application: this.application,
      initialState: {
        courtCaseConnectionTypeList: []
      }
    });
    this.getAllCourtCaseConnectionTypesInteractor
      .execute()
      .then(this.output?.loadAllCourtCaseConnectionTypes);
    return this.output;
  }
}
